import { ContentData } from "../../src/apis/stateful-content";
import { ColumnTypes } from "../../src/components/stateful-content/stateful-table/column-types";
import { StatusType } from "@trumpf/ux.ui-widgets/dist/collection/components/status/status-types";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const confirmed: StatusType = "ORDER_UNKNOWN";
const activated: StatusType = "ORDER_COMPLETE";

const response: ContentData = {
    totalCount: 10,
    filteredCount: 20,
    labelCount: "Treffer",
    schema: {
        email: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": true,
        },
        status: {
            type: ColumnTypes.Status,
            sortable: true,
            "primary-mobile": false,
        },
        detail: {
            type: ColumnTypes.DetailLink,
            sortable: false,
            "primary-mobile": false,
        },
    },
    items: [
        {
            email: "hanspeter.peterle@firma.de",
            status: activated,
            detailLink: "#",
        },
        {
            email: "hanspeter.peterlehanspeter.peterle@firma.de",
            status: confirmed,
            detailLink: "#",
        },
        {
            email: "hanspeter.peterle@firma.de",
            status: activated,
            detailLink: "#",
        },
        {
            email: "hanspeter.peterle@firma.de",
            status: activated,
            detailLink: "#",
        },
        {
            email: "hanspeter.peterle@firma.de",
            status: confirmed,
            detailLink: "#",
        },
    ],
};

const writeToFile = (object: ContentData, name: string) => {
    console.log(JSON.stringify(object));
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "user-admin-overview");
